import Container from "@material-ui/core/Container";
import BackButton from "./Buttons/BackButton"
import React, { Component } from 'react';
import Toolbar from "./Menu/Toolbar";
import SideDrawer from "./Menu/SideDrawer";
import BackDrop from "./Menu/BackDrop";
import { Row } from "react-grid-system";
import "./PersonStyle.css";
import WhatsappButton from "./Buttons/WhatsappButton";
import MailButton from "./Buttons/MailButton";
import Accordion from "./FAQ/Accordion";


// const data = {
//   title: "שאלות ותשובות נפוצות",
//   rows: [
//     {
//       title: "למי האפליקציה מיועדת?",
//       content: "להורים לילדים עם צרכים מיוחדים שמחפשים בייביסיטר מיוחד ולאנשים עם ניסיון וזיקה לתחום המעוניינים לעשות בייביסיטר."
//     },
//     {
//       title: "איך האפליקציה עובדת?",
//       content: "הורה לילד מיוחד? אחרי שנרשמת לאפליקציה את.ה יכול.ה לראות מי הבייביסיטרים המיוחדים המוצעים ולפנות אליהם באופן ישיר. בנוסף, ישנה אפשרות לפרסם בקשה ספציפית לבייביסיטר, ההודעה תגיע לבייביסיטר שיכול להיות רלוונטי ובמידה ומתאים הבייביסיטר י.תיצור קשר וכך תוכלו לתאם. בייביסיטר מהתחום? אחרי שנרשמת לאפליקציה, הורים לילדים מיוחדים יוכלו ליצור איתך קשר באופן ישיר. בנוסף לכך, כאשר תהייה בקשה לבייביסיטר שיכולה להיות רלוונטית עבורך תקבל.י הודעה ישירות לנייד ובמידה ומתאים לך תוכל.י ליצור קשר עם אותו הורה."
//     },
//     {
//       title: "האם השימוש באפליקציה הוא בתשלום?",
//       content: "לא."
//     },
//     {
//       title: " איך אני אדע כמה לשלם לבייביסיטר המיוחד או איזה תשלום לקחת עבור בייביסיטר מיוחד?",
//       content: "התשלום תלוי בגורמים שונים ביניהם מיקום, זמן, מספר ילדים ועוד. התשלום נקבע בין ההורה לבייביסיטר ואנו מצפים להתחשבות משני הצדדים. מההורים לשלם סכום הוגן בהתאם לסיטואציה הקיימת, מהבייביסיטרים המיוחדים אנחנו מבקשים לא להפריז בסכום שהורים אינם יכולים לעמוד בו."
//     },
//     {
//       title: "רגע, האם הבייביסיטרים המיוחדים עוברים הכשרה? איך אני אדע שאפשר לסמוך עליהם?",
//       content: "הבייביסיטרים המיוחדים לא עוברים הכשרה מטעמנו, אך אנו מייעדים את האפליקציה לבייביסיטרים בעלי ניסיון בתחום וממליצים להורים לבדוק ולברר מהי ההכשרה והניסיון של הבייביסיטר המיוחד ובמקרה הצורך לבקש המלצות."
//     },
//     {
//       title: "משפחה ביקשה בייביסיטר מיוחד לזמנים קבועים ואני קצת חושש/ת להתחייב, איך מומלץ לי לפעול?",
//       content: "אנחנו ממליצים לעשות שיחה מקדימה עם ההורים ולשמוע כמה שיותר פרטים על המצופה ממך בזמן הבייביסיטר. בנוסף, כדאי לקבוע פגישת תיאום והיכרות לניסיון בה תוכלי.י להבין האם יש חיבור בינך לבין המשפחה והילד והאם את.ה והמשפחה מעוניינים להמשיך ולהתחייב."
//     }]
// }


// const styles = {
//   arrowColor: 'red',
//   titleTextColor: 'black',
//   rowTitleColor: 'black',
// };

export default class CommonQA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      allData: {},
      menuOpen: false,
    };
  }
  
  menuClickHandler = () => {
    this.setState((prevState) => {
      return { menuOpen: !prevState.menuOpen };
    });
  };

  backDropClickHandler = () => {
    this.setState({ menuOpen: false });
  };

  render() {
    let sideDrawer;
    let backDrop;

    if (this.state.menuOpen) {
      sideDrawer = <SideDrawer closeMenu={this.backDropClickHandler} />;
      backDrop = <BackDrop click={this.backDropClickHandler} />;
    }
    
    return (
      <Container component="main" maxWidth="">
          <Toolbar drawerClickHandler={this.menuClickHandler} textPage="שאלות ותשובות נפוצות"/>
          {sideDrawer}
          {backDrop}
          <BackButton ></BackButton>
          <div>
            <div>
            <Accordion
                title= "למי האפליקציה מיועדת?"
                content="להורים לילדים עם צרכים מיוחדים שמחפשים בייביסיטר מיוחד ולאנשים עם ניסיון וזיקה לתחום המעוניינים לעשות בייביסיטר. "
                />
                <Accordion
                 title= "איך האפליקציה עובדת?"
                 content= "הורה לילד מיוחד? אחרי שנרשמת לאפליקציה את/ה יכול/ה לראות מי הבייביסיטרים המיוחדים המוצעים ולפנות אליהם באופן ישיר. בנוסף, ישנה אפשרות לפרסם בקשה ספציפית לבייביסיטר מיוחד, ההודעה תגיע לבייביסיטר מיוחד שיכול להיות רלוונטי ובמידה ומתאים הבייביסיטר המיוחד י/תיצור קשר וכך תוכלו לתאם. בייביסיטר מהתחום? אחרי שנרשמת לאפליקציה, הורים לילדים מיוחדים יוכלו ליצור איתך קשר באופן ישיר. בנוסף לכך, כאשר תהיה בקשה לבייביסיטר מיוחד שיכולה להיות רלוונטית עבורך תקבל/י הודעה ישירות לנייד ובמידה ומתאים לך תוכל/י ליצור קשר עם אותו הורה."
                />
                <Accordion
                  title= "האם השימוש באפליקציה הוא בתשלום?"
                  content= "לא."
                />
                <Accordion
                  title= "איך אני אדע כמה לשלם לבייביסיטר המיוחד או איזה תשלום לקחת עבור בייביסיטר?"
                  content= "התשלום תלוי בגורמים שונים ביניהם מיקום, זמן, מספר ילדים ועוד. התשלום נקבע בין ההורה לבייביסיטר המיוחד ואנו מצפים להתחשבות משני הצדדים. מההורים לשלם סכום הוגן בהתאם לסיטואציה הקיימת, מהבייביסיטרים המיוחדים אנחנו מבקשים לא להפריז בסכום שהורים אינם יכולים לעמוד בו."
                />
                  <Accordion
                 title= "רגע, האם הבייביסיטרים המיוחדים עוברים הכשרה? איך אני אדע שאפשר לסמוך עליהם?"
                 content= "הבייביסיטרים המיוחדים לא עוברים הכשרה מטעמנו, אך אנו מייעדים את האפליקציה לבייביסיטרים בעלי ניסיון בתחום וממליצים להורים לבדוק ולברר מהי ההכשרה והניסיון של הבייביסיטר המיוחד ובמקרה הצורך לבקש המלצות."
                 />
                  <Accordion
                  title= "משפחה ביקשה בייביסיטר מיוחד לזמנים קבועים ואני קצת חושש/ת להתחייב, איך מומלץ לי לפעול?"
                  content= "אנחנו ממליצים לעשות שיחה מקדימה עם ההורים ולשמוע כמה שיותר פרטים על המצופה ממך בזמן הבייביסיטר. בנוסף, כדאי לקבוע פגישת תיאום והיכרות לניסיון בה תוכל/י להבין האם יש חיבור בינך לבין המשפחה והילד והאם את/ה והמשפחה מעוניינים להמשיך ולהתחייב."
                  />
            </div>
            <div>
            <p>
              <div>לשאלות נוספות אתם מוזמנים לפנות אלינו באחת מהדרכים הבאות:</div>
              <Row height="80%">
                <div className="buttons_style" >
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <MailButton attributes="bbmeyuchad@gmail.com"/>
                  <WhatsappButton attributes="0556876741" qa="true"/>
                </div>
              </Row>
            </p>
            </div>
            <p>
              <div>בברכה, </div>
              <div>צוות בייביסיטר מיוחד במינו</div>
              <div>בשיתוף 'עדי בשבילכם'</div>
            </p>
          </div>
      </Container>
    )
  }
}